var _path;
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19,15l-1.41-1.41L13,18.17V2H11v16.17l-4.59-4.59L5,15l7,7L19,15z"
  }));
};
export default SvgArrowDown;